module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//johannmiller.com/resume.pdf"
    }
  }, [_vm._v("resume")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/johannkm"
    }
  }, [_vm._v("github")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/johannkm/"
    }
  }, [_vm._v("linkedin")])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "3em"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n    In 2019, I interned at "), _c('a', {
    attrs: {
      "href": "https://databricks.com"
    }
  }, [_vm._v("databricks")]), _vm._v(". I built a monitoring pipeline with Kafka, and wrote about it in this\n     "), _c('a', {
    attrs: {
      "href": "https://databricks.com/blog/2019/05/06/real-time-distributed-monitoring-and-logging-in-the-azure-cloud.html"
    }
  }, [_vm._v("blog post")]), _vm._v(".\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://databricks.com/blog/2019/05/06/real-time-distributed-monitoring-and-logging-in-the-azure-cloud.html"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pipeline.png")
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n    In 2017 I worked on "), _c('a', {
    attrs: {
      "href": "https://sidewalk-sea.cs.washington.edu"
    }
  }, [_vm._v("project sidewalk")]), _vm._v(". I investigated methods for predicting the quality of crowd-sourced data, and wrote this "), _c('a', {
    attrs: {
      "href": "https://johannkm.github.io/cmsc499A/"
    }
  }, [_vm._v("report")]), _vm._v(".\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://johannkm.github.io/cmsc499A/"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": require("../assets/sidewalk.jpg")
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n    At HopHacks (the Johns Hopkins hackathon), I worked with friends to build a VR app that helps with public speaking. We won 1st place overall.\n    You can read about our project on "), _c('a', {
    attrs: {
      "href": "//devpost.com/software/speechportal"
    }
  }, [_vm._v("devpost")]), _vm._v(". The event was also covered by the "), _c('a', {
    attrs: {
      "href": "//www.baltimoresun.com/news/maryland/education/higher-ed/bs-md-johns-hopkins-hophacks-20170219-story.html"
    }
  }, [_vm._v("baltimore sun")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "//hub.jhu.edu/2017/02/20/hophacks-spring-2017-memory-app/"
    }
  }, [_vm._v("jhu hub")]), _vm._v(".\n  ")]), _vm._v(" "), _c('blockquote', {
    staticClass: "twitter-tweet tw-align-center",
    attrs: {
      "data-lang": "en"
    }
  }, [_c('p', {
    attrs: {
      "lang": "en",
      "dir": "ltr"
    }
  }, [_vm._v("Congrats to Kevin Chen, Johann Miller, Ricky Han, and Jason Zou for winning the Hopkins Hackathon with their hack Speechportal! "), _c('a', {
    attrs: {
      "href": "https://t.co/vu9LzCM7Si"
    }
  }, [_vm._v("https://t.co/vu9LzCM7Si")])]), _vm._v("— UMD CS Department (@umdcs) "), _c('a', {
    attrs: {
      "href": "https://twitter.com/umdcs/status/833748457210929153"
    }
  }, [_vm._v("February 20, 2017")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    attrs: {
      "id": "part-2"
    }
  }, [_vm._v("\n    In 2016 I interned at the National Cancer Institute in Bruce Shapiro's RNA structure and design lab. I wrote software to predict 3D RNA structure like this:\n  ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/triangleChimera.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n    This model was used in a research paper in "), _c('a', {
    attrs: {
      "href": "//www.ncbi.nlm.nih.gov/pubmed/28108656"
    }
  }, [_vm._v("nucleic acids research")]), _vm._v(".\n  ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//johannmiller.com/resume.pdf"
    }
  }, [_vm._v("resume")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//github.com/johannkm"
    }
  }, [_vm._v("github")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/johannkm/"
    }
  }, [_vm._v("linkedin")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-929cb440"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CodePage.vue
// module id = 33
// module chunks = 0